import { render, staticRenderFns } from "./message.vue?vue&type=template&id=5bcc2af9&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=5bcc2af9&prod&lang=stylus&scoped=true&external"
import style1 from "./message.vue?vue&type=style&index=1&id=5bcc2af9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc2af9",
  null
  
)

export default component.exports